import HeroWithFeatureImage from 'components/hero/HeroWithFeatureImage'
import HeroWithIconGroup from 'components/hero/HeroWithIconGroup'
import HomeHero from 'components/hero/HomeHero'
import SingleTextHero from 'components/hero/SingleTextHero'
import React, { Fragment, FunctionComponent, ReactElement } from 'react'

type Props = {
  data: any
}

type AvailableComponents = { [key: string]: ReactElement }

const HeroRenderer: FunctionComponent<Props> = (props) => {
  const componentEntries: AvailableComponents = {
    'hero.home-hero': <HomeHero data={props.data} />,
    'hero.single-text-hero': <SingleTextHero data={props.data} />,
    'hero.hero-with-feature-image': <HeroWithFeatureImage data={props.data} />,
    'hero.hero-with-icon-group': <HeroWithIconGroup data={props.data} />,
  }
  return (
    <Fragment>
      <div className="lg:pt-10">{componentEntries[props.data.component]}</div>
    </Fragment>
  )
}

export default HeroRenderer
